import slice from './contentTabsSlice';

export * from './contentTabsSlice';

export default slice;
